import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=cafa8672&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=cafa8672&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa8672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafa8672')) {
      api.createRecord('cafa8672', component.options)
    } else {
      api.reload('cafa8672', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=cafa8672&scoped=true", function () {
      api.rerender('cafa8672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/AdditionalInfo.vue"
export default component.exports